import React from 'react'
import { EnergyMode } from '@vacationtracker/shared/types/user-insight'

interface IEnergyBarProps {
  score: number // 0-100
  mode: EnergyMode
}

const EnergyBar: React.FC<IEnergyBarProps> = ({ score, mode }) => {
  const width = Math.max(0, Math.min(100, score))
  return (
    <div className="te-energy-bar">
      <div className={`te-energy-bar__fill te-energy-bar__fill--${mode}`} style={{ width: `${width}%` }} />
    </div>
  )
}

export default EnergyBar
